import React, { useEffect } from 'react';
import { Container, Row, Col, Image } from "react-bootstrap";
import service4 from "../../../assets/images/contact/service4.png"
import service2 from "../../../assets/images/contact/service2.png"
import service5 from "../../../assets/images/contact/service5.png"
import AOS from "aos";

const Map = () => {
    useEffect(() => {
        AOS.init({ duration: 2000, },);
    }, [])
    return (
        <>
            <section className='map_wrap'>
                <Container fluid>
                    <Row>
                        <Col sm={6} md={6} lg={5} xl={5}>
                            <div className='map_title'>
                                <h2>We are here to help</h2>
                            </div>
                            <div className='map_description_wrap' data-aos='fade-right'>
                                <div className='map_details'>
                                    <div className='map_details_img'>
                                        <Image src={service4} alt='map details img' fluid />
                                    </div>
                                    <div className='map_details_text'>
                                        <h4>Support</h4>
                                        <p>Our support team will do their best to answer your<br /> inquiries. Contact us at info@urbanyogalab.com</p>
                                    </div>
                                </div>
                                <div className='map_details'>
                                    <div className='map_details_img'>
                                        <Image src={service2} alt='map details img' fluid />
                                    </div>
                                    <div className='map_details_text'>
                                        <h4>Support</h4>
                                        <p>Our support team will do their best to answer your<br /> inquiries. Contact us at info@urbanyogalab.com</p>
                                    </div>
                                </div>
                                <div className='map_details'>
                                    <div className='map_details_img'>
                                        <Image src={service5} alt='map details img' fluid />
                                    </div>
                                    <div className='map_details_text'>
                                        <h4>Support</h4>
                                        <p>Our support team will do their best to answer your<br /> inquiries. Contact us at info@urbanyogalab.com</p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col sm={6} md={6} lg={5} xl={5}>
                            <div className='main_map_wrap' data-aos='fade-left'>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d158857.84156697727!2d-0.26674708717399515!3d51.52873932347443!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a00baf21de75%3A0x52963a5addd52a99!2sLondon%2C%20UK!5e0!3m2!1sen!2sin!4v1693919927706!5m2!1sen!2sin" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default Map